export default "__VITE_ASSET__UztHY87L__"